import { Typography as TypographyMUI, TypographyProps } from '@mui/material'

export function Typography({ children, ...rest }: TypographyProps) {
  return (
    <TypographyMUI fontFamily="Montserrat" {...rest}>
      {children}
    </TypographyMUI>
  )
}
